// Angular
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function addressFieldsValidator( ignoreType = false): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    if (!(formGroup instanceof FormGroup)) {
      return null;
    }

    const addressType = formGroup.get('addressType')?.value?.value;
    const address1 = formGroup.get('address1')?.value;
    const city = formGroup.get('city')?.value;
    const state = formGroup.get('state')?.value;
    const zip = formGroup.get('zip')?.value;

    var fields = [ address1, city, state, zip];
    if(!ignoreType){
      fields = [...fields, addressType];
    }
    const isAnyFieldFilled = fields.some(field => !!field);

    // If any field is filled, ensure all fields are filled
    if (isAnyFieldFilled && ((ignoreType ? false : !addressType) || !address1 || !city || !state || !zip)) {
      return { addressFieldsRequired: true }; // Group-level error
    }
    return null;
  };
}

export function clerkReviewAddressFieldsValidator(): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    if (!(formGroup instanceof FormGroup)) {
      return null;
    }

    const type = formGroup.get('type')?.value;
    const streetLine1 = formGroup.get('streetLine1')?.value;
    const city = formGroup.get('city')?.value;
    const state = formGroup.get('state')?.value;
    const zipCode = formGroup.get('zipCode')?.value;
    const zipCodeExtension = formGroup.get('zipCodeExtension')?.value;

    const fields = [type, streetLine1, city, state, zipCode, zipCodeExtension];
    const isAnyFieldFilled = fields.some(field => !!field);

    // If any field is filled, ensure all required fields are filled
    if (isAnyFieldFilled && (!type || !city || !state || !zipCode)) {
      return { addressFieldsRequired: true };
    }

    return null;
  };
}
